var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('amplify-authenticator',{staticClass:"amplify-auth-form white",attrs:{"authConfig":_vm.authConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }